import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchLogo } from "../../services/apiService";

function EXHome() {
  const navigate = useNavigate();

  // ✅ logo is STRING, not array
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1️⃣ Fetch logo FIRST (uses centralized fetchLogo to deduplicate)
  useEffect(() => {
    fetchLogo()
      .then((data) => setLogo(data[0]?.logo || null))
      .catch((error) => console.error("Error fetching logo:", error))
      .finally(() => setLoading(false));
  }, []);

  // 2️⃣ Call iframe API ONLY after logo loaded
  useEffect(() => {
    if (loading || !logo) return;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const remote_id = localStorage.getItem("remote_id");

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/iframe/play`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({
              id: "eg_" + remote_id,
              token: token,

              // ✅ MUST be full origin
              providerSitePage: window.location.origin,
              origin: window.location.origin,

              // ✅ logo now guaranteed
              siteLogo: `${process.env.REACT_APP_API_URL}/storage/${logo}`,
            }),
          }
        );

        const dataly = await response.json();

        const iframeUrl = dataly?.data?.launch?.data?.launchUrl ?? dataly?.game_url;

        if (!iframeUrl) {
          throw new Error("Invalid iframe launch response");
        }

         if (iframeUrl.match(/mcwbd/gi) || dataly?.data?.fullRedir || iframeUrl.includes('#/9wkt')) {
  			  window.location.href = iframeUrl;
  			  return;
  		  }

        navigate("/gamerun", { state: { iframeUrl } });
      } catch (error) {
        console.error("Error fetching player login:", error);
      }
    };

    fetchData();
  }, [logo, loading, navigate]);

  return null;
}

export default EXHome;
